import { LOCALE_ID, Provider } from '@angular/core';

import { LangService } from '../services/lang.service';

export class LangId extends String {
  constructor(private localeService: LangService) {
    super();
  }

  toString(): string {
    return this.localeService.getActiveLocale();
  }

  valueOf(): string {
    return this.toString();
  }
}

export const langProvider: Provider = {
  provide: LOCALE_ID,
  useClass: LangId,
  deps: [LangService],
};
